import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LaunchDarklyService } from '../../../../../../core/services/launchdarkly.service';
import { EstimatePlansTakeOffsStatesV2 } from '../../feat-estimate-plans-take-offs-v2/domain';
import { EstimateMeasurementVM, EstimateMeasurementViewSettings } from '../feat-estimate-measurements-v2/domain';
import { EstimateMeasurementCalculatorService } from '../feat-estimate-measurements-v2/estimate-measurement-calculator.service';

@Component({
    selector: 'app-estimate-measurement-item-actions',
    templateUrl: './estimate-measurement-item-actions.component.html',
    styleUrls: ['./estimate-measurement-item-actions.component.scss'],
    standalone: false,
})
export class EstimateMeasurementItemActionsComponent implements OnChanges {
    // @ts-ignore TS2564
    @Input() estimateMeasurement: EstimateMeasurementVM;
    // @ts-ignore TS2564
    @Input() hasPlans: boolean;
    // @ts-ignore TS2564
    @Input() states: EstimatePlansTakeOffsStatesV2;
    // @ts-ignore TS2564
    @Input() viewSettings: EstimateMeasurementViewSettings;

    @Output() takeOffsChanges = new EventEmitter();
    @Output() calculateChanges = new EventEmitter();
    @Output() toggleMeasurementChanges = new EventEmitter<boolean>();
    @Output() deleteChanges = new EventEmitter();

    public isCalculated = false;

    constructor(private estimateMeasurementCalculatorService: EstimateMeasurementCalculatorService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.estimateMeasurement?.currentValue) {
            this.checkCalculation();
        }
    }

    private checkCalculation() {
        // @ts-ignore TS2345
        this.isCalculated = this.estimateMeasurementCalculatorService.isCalculated(this.estimateMeasurement.expression);
    }

    public onTakeOff() {
        this.takeOffsChanges.emit();
    }

    public onCalculate() {
        this.calculateChanges.emit();
    }

    public onShowMeasurement() {
        this.toggleMeasurementChanges.emit(true);
    }

    public onHideMeasurement() {
        this.toggleMeasurementChanges.emit(false);
    }

    public onDelete() {
        this.deleteChanges.emit();
    }
}

@NgModule({
    declarations: [EstimateMeasurementItemActionsComponent],
    imports: [CommonModule, BsDropdownModule, TooltipModule],
    exports: [EstimateMeasurementItemActionsComponent],
})
export class EstimateMeasurementItemActionsModule {}
